import React from 'react';
import PropTypes from 'prop-types';

class ControledSelect extends React.Component {
    getOptionFromValue(value, options) {
        const {optionValuePropertyName} = this.props;
        return options.find(o => o[optionValuePropertyName] === value);
    }

    getSelectedText() {
        const {
            optionTextPropertyName,
            options,
            placeholder,
            value
        } = this.props;
        const selectedOption = this.getOptionFromValue(value, options);

        if (selectedOption) {
            return selectedOption[optionTextPropertyName];
        }

        if (placeholder) {
            return placeholder;
        }

        return options[0]?.[optionTextPropertyName];
    }

    render() {
        const {
            disabled,
            name,
            options,
            optionTextPropertyName,
            optionValuePropertyName,
            placeholder,
            value,
            onChange,
            onBlur
        } = this.props;
        const isDisabled = disabled || options.length < 1;

        let className = 'controled-select';

        if (isDisabled) {
            className += ' disabled';
        }

        return (
            <div className={className}>

                <span className="selected-option">
                    {this.getSelectedText()}
                </span>

                <select
                    defaultValue={value}
                    disabled={isDisabled}
                    key={`${name}-${value}`}
                    name={name}
                    onChange={onChange}
                    onBlur={onBlur}
                >
                    {
                        placeholder && (
                            <option disabled value="">{placeholder}</option>
                        )
                    }
                    {options.map(option => (
                        <option
                            value={option[optionValuePropertyName]}
                            key={`${option[optionTextPropertyName]}-${option[optionValuePropertyName]}`}
                        >
                            {option[optionTextPropertyName]}
                        </option>
                    ))}
                </select>

                {
                    !isDisabled && <span className="icon-chevron-down" />
                }

            </div>
        );
    }
}

ControledSelect.propTypes = {
    disabled: PropTypes.bool,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    optionTextPropertyName: PropTypes.string,
    optionValuePropertyName: PropTypes.string,
    options: PropTypes.arrayOf(PropTypes.object),
    placeholder: PropTypes.string,
    value: PropTypes.string
};

ControledSelect.defaultProps = {
    disabled: false,
    onChange: null,
    options: [],
    placeholder: '',
    value: '',
    optionTextPropertyName: 'name',
    optionValuePropertyName: 'id'
};

export default ControledSelect;
